import React from 'react';
import PropTypes from 'prop-types';
import ChosenSelect from './ChosenSelect';

const EventFilter = ({ options, value, onChange }) => {
  const renderGroupedOptions = (events, renderOption) => {
    const groups = events.reduce((result, event) => {
      const group = event.subsystem || 'Other';
      result[group] = result[group] || [];
      result[group].push(event);
      return result;
    }, {});

    return Object.entries(groups).map(([group, groupEvents]) => (
      <optgroup key={group} label={group}>
        {groupEvents.map(event => (
          <option key={String(event.value)} value={event.value}>{renderOption(event)}</option>
        ))}
      </optgroup>
    ));
  };

  return (
    <div className="eventSelection">
      <div className="chartControlTitle" data-testid="analysis-filters-panel-events-label">Event IDs</div>
      <div className="input-group eventSelectorGroup">
        <i className="fas fa-search input-group-addon" />
        <ChosenSelect
          options={options}
          value={(value || []).map(option => option.value)}
          multiple
          className="eventSelect"
          onChange={selectedValues => onChange(options.filter(option => selectedValues.includes(String(option.value))))}
          renderOption={event => `${event.title} — [${event.value}]`}
          renderGroup={renderGroupedOptions}
          testId="analysis-filters-panel-events-select"
        />
        <span className="input-group-addon">
          <button type="button" className="analysis-filter-clear" title="Clear selection" aria-label="Clear event IDs selection"
            onClick={() => onChange([])} data-testid="analysis-filters-panel-events-clear">
            <i className="fas fa-times" aria-hidden="true" />
          </button>
        </span>
      </div>
    </div>
  );
};

EventFilter.propTypes = {
  options: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default EventFilter;